import { Activity } from "lucide-react";
import { getFilterByFilterName, type FilterCategory } from "../config";
import { createFilterGroup, filterGroupTypes } from "../filter-types";

export const performanceFilterCategory = {
  title: "Præstationsevne",
  id: "performance",
  icon: Activity,
  description: "Virksomhedernes økonomiske udvikling",
  filters: {
    growthCompany: createFilterGroup({
      id: "growth-company",
      title: "Vækstvirksomhed",
      keywords: ["bruttofortjeneste", "medarbejdere"],
      description:
        "Virksomheder der er hurtigt voksende, og som minimum har fordoblet deres bruttofortjeneste og/eller medarbejderantal inden for de seneste tre år.",
      filters: {
        value: {
          fieldName: "Financial.Analytics.Cheetah",
          filterName: "performance-growth-company",
        },
      },
      filterType: filterGroupTypes.checkmark,
      checkLabel: "Er vækstvirksomhed",
      DisplayValue: ({ filters }) => {
        const growthCompanyFilter = getFilterByFilterName(
          "performance-growth-company",
          filters,
        );
        if (growthCompanyFilter?.values?.[0] === "true") {
          return "Ja";
        }
        return "Ingen betydning";
      },
    }),
    liquidCompany: createFilterGroup({
      id: "liquid-company",
      title: "Likvid virksomhed",
      keywords: ["betalingsevne", "likviditet"],
      description:
        "Virksomheder med en sund økonomi og god likviditet, der har en solid evne til at betale deres regninger og forpligtelser til tiden.",
      filterType: filterGroupTypes.checkmark,
      checkLabel: "Er likvid",
      filters: {
        value: {
          fieldName: "isLiquidCompany",
          filterName: "performance-liquid-company",
        },
      },
      DisplayValue: ({ filters }) => {
        const liquidCompanyFilter = getFilterByFilterName(
          "performance-liquid-company",
          filters,
        );
        if (liquidCompanyFilter?.values?.[0] === "true") {
          return "Ja";
        }
        return "Ingen betydning";
      },
    }),
    cashCow: createFilterGroup({
      id: "cash-cow",
      title: "Cash cow",
      keywords: ["udbytte", "overskud"],
      description:
        "Virksomheder, der udbetaler størstedelen af deres overskud i form af udbytte, i stedet for at geninvestere overskuddet i virksomheden.",
      filterType: filterGroupTypes.checkmark,
      checkLabel: "Er cash cow",
      filters: {
        value: {
          fieldName: "Financial.Analytics.CashCow",
          filterName: "performance-cash-cow",
        },
      },
      DisplayValue: ({ filters }) => {
        const cashCowFilter = getFilterByFilterName(
          "performance-cash-cow",
          filters,
        );
        if (cashCowFilter?.values?.[0] === "true") {
          return "Ja";
        }
        return "Ingen betydning";
      },
    }),
    distressed: createFilterGroup({
      id: "distressed",
      title: "Økonomisk udfordret virksomhed",
      keywords: [
        "vanskeligheder",
        "negativ egenkapital",
        "underskud",
        "konkurs",
      ],
      description:
        "Virksomheder som har økonomiske udfordringer, som kan ses i form af negativ egenkapital, underskud eller andre økonomiske vanskeligheder.",
      filterType: filterGroupTypes.checkmark,
      checkLabel: "Er økonomisk udfordret",
      filters: {
        value: {
          fieldName: "Financial.Analytics.Distressed",
          filterName: "performance-distressed",
        },
      },
      DisplayValue: ({ filters }) => {
        const distressedFilter = getFilterByFilterName(
          "performance-distressed",
          filters,
        );
        if (distressedFilter?.values?.[0] === "true") {
          return "Ja";
        }
        return "Ingen betydning";
      },
    }),
    profitable: createFilterGroup({
      id: "profitable",
      title: "Driftdygtig virksomhed",
      keywords: ["indtjening", "overskud", "rentabel"],
      description:
        "Virksomheder som har en stabil og effektiv drift med god indtjening i forhold til omsætningen.",
      filters: {
        value: {
          fieldName: "Financial.Analytics.Profitable",
          filterName: "performance-profitable",
        },
      },
      filterType: filterGroupTypes.checkmark,
      checkLabel: "Er driftdygtig virksomhed",
      DisplayValue: ({ filters }) => {
        const profitableFilter = getFilterByFilterName(
          "performance-profitable",
          filters,
        );
        if (profitableFilter?.values?.[0] === "true") {
          return "Ja";
        }
        return "Ingen betydning";
      },
    }),
  },
} satisfies FilterCategory;
